import { usePutQuotingProspectsId } from 'utils/web_api'
import { type QuotingProspect, type QuotingProspectQuoteRequestStatus } from 'utils/web_api.schemas'

import { useProspect } from './ProspectProvider'

interface UseQuoteRequestProgressProps {
  step: QuotingProspectQuoteRequestStatus
  onSuccess: (prospect: QuotingProspect) => Promise<unknown> | unknown
}

export const useQuoteRequestProgress = ({ step, onSuccess }: UseQuoteRequestProgressProps) => {
  const { prospect } = useProspect()

  const { mutate: updateProspect } = usePutQuotingProspectsId({
    mutation: {
      onSuccess: (data) => {
        window.segment?.track('Complete quote request step', { id: prospect?.id, step })
        onSuccess(data)
      }
    },
  })

  return {
    completeStep: () => {
      updateProspect({ id: prospect!.id, data: { completed_quote_request_step: step } })
    }
  }
}
